import { Heart } from 'lucide-react';
import iolabsLogo from '../../assets/iolabs.svg';

export const Footer = () => {
  return (
    <footer className="border-t border-gray-200 bg-white px-4 py-2">
      <div className="flex items-center justify-between text-xs text-gray-500">
        <div className="flex items-center space-x-4">
          <span>Copyright © {new Date().getFullYear()} ioLabs AG</span>
          <span>|</span>
          <span>
            Powered by{' '}
            <a
              href="https://iolabs.ch/en/ioframework/"
              target="_blank"
              rel="noopener noreferrer"
              className="transition-opacity hover:opacity-80"
            >
              ioFramework
            </a>
          </span>
        </div>
        <div className="relative">
          Made with{' '}
          <Heart className="relative bottom-[2px] mx-1 inline-block h-4 w-4 text-red-500 fill-red-500" />{' '}
          in Switzerland
        </div>
        <div className="flex items-center space-x-4">
          <span>Version 1.0.0</span>
          <a
            href="https://iolabs.ch"
            target="_blank"
            rel="noopener noreferrer"
            className="transition-opacity hover:opacity-80"
          >
            <img src={iolabsLogo} alt="IoLabs" className="h-4 w-auto" />
          </a>
        </div>
      </div>
    </footer>
  );
};
